import styled from 'styled-components';

export const AnchorDiv = styled.div`
    position: relative;
    height: 0px;
    width: 0px;
    pointer-events: all;
`